import {Component, OnInit} from '@angular/core';
import {Roles} from '../../enums/enums';
import {Router} from '@angular/router';
import {SessionService} from '../../services/session.service';
import {DataStore, SortDirection} from '@aws-amplify/datastore';
import {Contract, Team, User} from '../../../models';
import {PermissionType} from '../../API.service';
import {Predicates} from 'aws-amplify';

@Component({
    selector: 'app-agent-home-menu',
    templateUrl: './agent-home-menu.component.html',
    styleUrls: ['./agent-home-menu.component.scss'],
})
export class AgentHomeMenuComponent implements OnInit {
    sortDirection = SortDirection.ASCENDING;
    contractsCount: number;
    clientsCount: number;
    myTeamId: string;
    teammates = 0;
    cssClass: any;

    constructor(
        private router: Router,
        private sessionService: SessionService,
    ) {
    }

    async ngOnInit() {
        const currentUser = this.sessionService.getCurrentUser();
        this.contractsCount = (await DataStore.query(Contract)).filter(c => c.clientId == currentUser?.id).length;

        // this.clientsCount = (await DataStore.query(User, u => u.role("eq", Roles.CLIENT.displayName))).length;
        const users = await DataStore.query(User,  Predicates.ALL, {
            sort: s => s.lastname(this.sortDirection).name(this.sortDirection),
        });
        this.clientsCount = (users.filter(u => u.permessions == PermissionType.CLIENT && u.addedBy == this.sessionService.user?.id)).length;

        const team = (await DataStore.query(Team)).filter(t => t.manager?.id == this.sessionService.user?.id);
        try {
            this.myTeamId = team[0]?.id || undefined;
            this.teammates = (await DataStore.query(User, u => u.teamID('eq', this.myTeamId))).length;
        } catch (e) {
            
            this.myTeamId = null;
        }
    }

    openPage(page: string) {
        return this.router.navigate([page]);
    }

    async openMyTeamPage() {
        // const teamId = DataStore.query(Team, )
        return this.router.navigate(['/teams', this.sessionService.getCurrentUser().id]);
    }

}
